import { render, staticRenderFns } from "./StatusTag.vue?vue&type=template&id=81a305e0&scoped=true"
import script from "./StatusTag.vue?vue&type=script&lang=js"
export * from "./StatusTag.vue?vue&type=script&lang=js"
import style0 from "./StatusTag.vue?vue&type=style&index=0&id=81a305e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a305e0",
  null
  
)

export default component.exports